import React, { FC } from "react";

interface IProps {
  children: React.ReactElement;
}

const Main: FC<IProps> = ({ children }) => <main className="layout-main">{children}</main>;

export default Main;
